import { RevealOnScroll, StaggerChildren, StaggerItem } from './MotionComponents';

const steps = [
  { num: '01', title: 'Entendemos', desc: 'Analizamos el contexto antes de recomendar.' },
  { num: '02', title: 'Identificamos', desc: 'Seleccionamos los perfiles con mayor capacidad de aportar valor.' },
  { num: '03', title: 'Activamos', desc: 'Facilitamos una conexión estructurada y confidencial.' },
];

export default function HowItWorks() {
  return (
    <section
      id="proceso"
      data-testid="how-it-works-section"
      className="bg-[#00163E] py-32 md:py-40 relative overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-[#00163E] to-[#001F4F]" />
      <div className="grain absolute inset-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <RevealOnScroll className="mb-20 md:mb-24">
          <span className="text-[#C58C40] text-xs font-medium tracking-[0.2em] uppercase block mb-6">
            Cómo funciona
          </span>
          <h2
            data-testid="how-it-works-headline"
            className="text-3xl md:text-4xl font-normal tracking-[0.01em] leading-snug text-white max-w-xl"
          >
            Tres principios. Un protocolo.
          </h2>
        </RevealOnScroll>

        <div className="relative">
          <div className="hidden md:block absolute top-[21px] left-[21px] right-[21px] h-[1px] bg-white/15 z-0" />

          <StaggerChildren className="grid grid-cols-1 md:grid-cols-3 gap-0" staggerDelay={0.15}>
            {steps.map((step, i) => (
              <StaggerItem key={step.num}>
                <div
                  data-testid={`how-step-${i}`}
                  className="relative"
                >
                  <div className="relative z-10 py-8 md:py-0 md:pr-12">
                    <div className="flex items-center gap-5 mb-8">
                      <div className="w-[42px] h-[42px] rounded-full border border-[#C58C40]/40 flex items-center justify-center bg-[#00163E] relative z-10">
                        <span className="text-[#C58C40] text-sm font-medium">{step.num}</span>
                      </div>
                      {i < steps.length - 1 && (
                        <div className="md:hidden flex-1 h-[1px] bg-white/15" />
                      )}
                    </div>
                    <h3 className="text-white text-2xl md:text-3xl font-normal mb-4 tracking-wide">
                      {step.title}
                    </h3>
                    <p className="text-[#8A9BB1] text-base leading-relaxed max-w-xs">
                      {step.desc}
                    </p>
                  </div>
                  {i < steps.length - 1 && (
                    <div className="md:hidden h-[1px] w-full bg-white/10" />
                  )}
                </div>
              </StaggerItem>
            ))}
          </StaggerChildren>
        </div>
      </div>
    </section>
  );
}
